<app-page-shell>
  <p-toast></p-toast>
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>

  <app-page-hero eyebrow="CRM Merchandisers" title="Merchandisers" subtitle="Manage the merchandiser master records used by client accounts and POSM projects.">
    <div actions>
      <p-button label="Refresh" icon="pi pi-refresh" severity="secondary" [outlined]="true" (click)="loadRows()"></p-button>
      <p-button label="New Merchandiser" icon="pi pi-plus" (click)="openNew()"></p-button>
    </div>
  </app-page-hero>

  <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

  <app-page-search-panel title="Search Merchandisers" [activeFilters]="activeSearchCount" [collapsed]="true" (clear)="clearSearch()" (search)="applySearch()">
    <div class="grid p-fluid">
      <div class="field col-12 md:col-8">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-search"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <input id="merchandiserSearch" pInputText [value]="searchText()" (input)="searchText.set($any($event.target).value)" (keydown.enter)="applySearch()">
            <label for="merchandiserSearch">Search name, phone, email, employee code</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-4">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-check-circle"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="merchandiserActive" [options]="activeOptions" optionLabel="label" optionValue="value" [ngModel]="activeFilter()" (ngModelChange)="activeFilter.set($event)" [showClear]="true" styleClass="w-full"></p-select>
            <label for="merchandiserActive">Status</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
    </div>
  </app-page-search-panel>

  <app-page-data-panel title="Merchandiser Directory" [subtitle]="lastUpdatedText" [resultText]="rows().length + ' records'">
    <p-table [value]="rows()" [lazy]="true" (onLazyLoad)="loadRows($event)" [first]="first()" [rows]="pageRows()" [totalRecords]="totalRecords()" [paginator]="true" [loading]="loading()" [rowHover]="true" dataKey="id" styleClass="p-datatable-sm p-datatable-gridlines" [tableStyle]="{ 'min-width': '72rem' }">
      <ng-template pTemplate="header">
        <tr>
          <th>Merchandiser</th>
          <th>Contact</th>
          <th>Region</th>
          <th>Status</th>
          <th>Updated</th>
          <th class="text-center" style="width: 10rem">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>
            <div class="font-semibold text-900">{{ row.name }}</div>
            <div class="text-xs text-500 mt-1">{{ row.merchandiserNumber || 'Number pending' }} · {{ row.employeeCode || 'No employee code' }}</div>
          </td>
          <td>
            <div>{{ row.emailAddress || '-' }}</div>
            <div class="text-xs text-500 mt-1">{{ row.mobileNumber || row.phoneNumber || 'No phone' }}</div>
          </td>
          <td>{{ row.region || '-' }}</td>
          <td><p-tag [value]="row.active === false ? 'Inactive' : 'Active'" [severity]="row.active === false ? 'warn' : 'success'"></p-tag></td>
          <td>{{ row.updatedAt || row.createdAt | date:'medium' }}</td>
          <td class="text-center">
            <button pButton icon="pi pi-eye" class="p-button-rounded p-button-text" (click)="view(row)" pTooltip="View"></button>
            <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-secondary" (click)="edit(row)" pTooltip="Edit"></button>
            <button pButton icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger" (click)="delete(row)" pTooltip="Delete"></button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" class="text-center p-5">No merchandisers found.</td>
        </tr>
      </ng-template>
    </p-table>
  </app-page-data-panel>
</app-page-shell>
